import { render } from "./CollectionSetUp.vue?vue&type=template&id=5554c64a"
import script from "./CollectionSetUp.vue?vue&type=script&lang=ts"
export * from "./CollectionSetUp.vue?vue&type=script&lang=ts"
script.render = render

export default script